import React from 'react';
import { clickBannerKakao } from '@library/Utils';

export type NoAuthBoxProps = {
  type: 'menu' | 'option' | 'order' | 'recommend' | 'origin';
};

const NoAuthBox = (props: NoAuthBoxProps) => {
  const { type } = props;

  const title = {
    menu: '메뉴',
    option: '옵션',
    order: '메뉴 순서',
    recommend: '추천 메뉴',
    origin: '원산지 정보',
  };

  return (
    <div className="box-empty auth-wrapper">
      <h4 className="screen-out">{`${title[type]} 관리 설정`}</h4>
      <img
        src="//image.thecupping.co.kr/partners/web/img-empty-data@2x.png"
        width="140"
        height="140"
        className="img-empty"
        alt=""
      />
      <p className="desc-empty">{`${title[type]} 관리에 대한 권한이 없습니다.`}</p>
      <p className="desc-empty-info">
        {`${title[type]} 수정은`}{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            clickBannerKakao();
          }}
        >
          [카카오톡 채널]
        </a>
        을<br />
        통해 요청해주세요.
      </p>
    </div>
  );
};

export default NoAuthBox;
